import { DatePicker } from '@ionic-native/date-picker';
import { ServerDetailsNewPage } from './../pages/server-details-new/server-details-new';
import { PosTablePage } from './../pages/pos-table/pos-table';
import { PosStatusPage } from './../pages/pos-status/pos-status';
import { PosSalePage } from './../pages/pos-sale/pos-sale';
import { PosRunningPage } from './../pages/pos-running/pos-running';
import { PosPaidPage } from './../pages/pos-paid/pos-paid';
import { PosDashboardPage } from './../pages/pos-dashboard/pos-dashboard';
import { PosCanceledPage } from './../pages/pos-canceled/pos-canceled';
import { PosTransactionPage } from './../pages/pos-transaction/pos-transaction';
import { LoginPage } from './../pages/login/login';
import { FoInventoryPage } from './../pages/fo-inventory/fo-inventory';
import { FoStatisticPage } from './../pages/fo-statistic/fo-statistic';
import { FoInhousePage } from './../pages/fo-inhouse/fo-inhouse';
import { FoInfoPage } from './../pages/fo-info/fo-info';
import { FoDeparturePage } from './../pages/fo-departure/fo-departure';
import { FoArrivalPage } from './../pages/fo-arrival/fo-arrival';
import { DashboardDetailPage } from './../pages/dashboard-detail/dashboard-detail';
import { DashboardPage } from './../pages/dashboard/dashboard';
import { CheckoutPage } from './../pages/checkout/checkout';
import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';

import { MyApp } from './app.component';
import { HomePage } from '../pages/home/home';
import { AuthProvider } from '../providers/auth/auth';
import { FoserviceProvider } from '../providers/foservice/foservice';
import { PosServiceProvider } from '../providers/pos-service/pos-service';
import { HttpClientModule } from '@angular/common/http';
import { IonicStorageModule } from '@ionic/storage';
import { FormsModule } from '@angular/forms';
import { PosDsPage } from '../pages/pos-ds/pos-ds';
import { FrontPage } from '../pages/front/front';
import { GlobalProvider } from '../providers/global/global';

@NgModule({
  declarations: [
    MyApp,
    HomePage,
    CheckoutPage,
    DashboardPage,
    DashboardDetailPage,
    FoArrivalPage,
    FoDeparturePage,
    FoInfoPage,
    FoInhousePage,
    FoInventoryPage,
    FoStatisticPage,
    LoginPage,
    PosCanceledPage,
    PosDashboardPage,
    PosPaidPage,
    PosRunningPage,
    PosSalePage,
    PosStatusPage,
    PosTablePage,
    PosTransactionPage,
    PosDsPage,
    ServerDetailsNewPage,
    FrontPage
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    FormsModule,
    IonicModule.forRoot(MyApp),
    IonicStorageModule.forRoot()
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    HomePage,
    CheckoutPage,
    DashboardPage,
    DashboardDetailPage,
    FoArrivalPage,
    FoDeparturePage,
    FoInfoPage,
    FoInhousePage,
    FoInventoryPage,
    FoStatisticPage,
    LoginPage,
    PosCanceledPage,
    PosDashboardPage,
    PosPaidPage,
    PosRunningPage,
    PosSalePage,
    PosStatusPage,
    PosTablePage,
    PosTransactionPage,
    PosDsPage,
    ServerDetailsNewPage,
    FrontPage
  ],
  providers: [
    StatusBar,
    SplashScreen,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    AuthProvider,
    FoserviceProvider,
    PosServiceProvider,
    DatePicker,
    GlobalProvider
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts